import { render, staticRenderFns } from "./AdminBenchmarkOverviewSection.vue?vue&type=template&id=9c58e958"
import script from "./AdminBenchmarkOverviewSection.vue?vue&type=script&lang=js"
export * from "./AdminBenchmarkOverviewSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports